'use client'

/**
 * The four pricing trust bullets (Pricing v2 Stage 1) — one component so the
 * copy can never diverge across surfaces again. Rendered on the marketing
 * pricing page, the select-plan page, and billing settings.
 */

import { useExtracted } from 'next-intl'
import { Check } from '@/components/ui/icons'
import { cn } from '@/lib/utils'

export function TrustBullets({ variant = 'app', className }: { variant?: 'marketing' | 'app'; className?: string }) {
  const t = useExtracted()
  const bullets = [
    t('Olives roll over for 12 months'),
    t('Cancel anytime — your olives stay'),
    t('No per-seat pricing'),
    t('Commercial license on every plan, including Free'),
  ]
  return (
    <ul
      className={cn(
        'flex flex-wrap items-center',
        variant === 'marketing'
          ? 'justify-center gap-x-8 gap-y-3 text-sm font-medium text-white/85'
          : 'gap-x-6 gap-y-2 text-xs text-muted-foreground',
        className,
      )}
    >
      {bullets.map(bullet => (
        <li key={bullet} className="flex items-center gap-2">
          <Check
            className={cn(
              'shrink-0',
              // Monochrome checks — the design system bans multi-colour chrome
              variant === 'marketing' ? 'h-4 w-4 text-white/50' : 'h-3.5 w-3.5 text-muted-foreground/60',
            )}
            strokeWidth={2.5}
          />
          {bullet}
        </li>
      ))}
    </ul>
  )
}
